import { useQuery } from 'react-query';

// Services
import CgiService from '../services/cgiService';

// Models
import { CgiCollectRequest, CgiCollectResponse } from '../models/CGI/CGI';
import { AxiosError, AxiosResponse } from 'axios';

interface Props {
  request?: CgiCollectRequest;
  enabled: boolean;
  onError: (err: AxiosError<any>) => void;
  onSuccess: (data: AxiosResponse<CgiCollectResponse>) => void;
  interval?: number;
}

const cgiService = new CgiService();

const useCgiPolling = ({ request, enabled, onError, onSuccess, interval = 2000 }: Props) => {
  const { data, status, isError } = useQuery(
    ['cgiPolling', request],
    () => request ? cgiService.collect(request) : null,
    {
      enabled: enabled,
      refetchOnReconnect: false,
      refetchOnMount: false,
      refetchOnWindowFocus: false,
      retry: 3,
      retryDelay: 3000,
      retryOnMount: false,
      refetchIntervalInBackground: true,
      refetchInterval: interval,
      onError,
      onSuccess
    }
  );

  return {
    data: data?.data,
    status,
    isError
  }
};

export default useCgiPolling;
